<template>
  <ModalDialog
    v-if="value"
    title="建立對戰"
    :hide-cancel="true"
    confirm-text="建立對局"
    :value="value"
    @input="onInput"
    @confirm="createLobby"
  >
    <LobbyCreateForm ref="lobbyCreateForm" />
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/Modal/ModalDialog.vue';
import LobbyCreateForm from '@/components/Pvp/LobbyCreateForm.vue';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LobbyCreateForm,
    ModalDialog,
  },
  data() {
    return {
      isCreating: false,
    };
  },
  methods: {
    async createLobby() {
      this.isCreating = true;
      await this.$refs.lobbyCreateForm.createRoom();
      this.isCreating = false;
      this.$emit('input', false);
    },
    onInput(value) {
      if (this.isCreating) return;
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
